/* eslint-disable react/no-unused-state */
import React from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';

import ReCAPTCHA from 'react-google-recaptcha';
import { authenticate } from '../../app/store/actions/auth';

import { history } from '../../routers/AppRouter';

import ROUTES from '../../data/routes';
import FIELDS from '../../data/fields';
import PreferencesData from '../../data/preferences';

export class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      message: '',
      reCaptchaVerify: window.location.hostname === 'localhost' ? PreferencesData.noReCaptcha : '',
      reCaptchaRef: React.createRef(),
    };
  }

  onEmailChange = (e) => {
    const email = e.target.value;
    this.setState(() => ({ email }));
  };

  onPasswordChange = (e) => {
    const password = e.target.value;
    this.setState(() => ({ password }));
  };

  onSubmit = async (e) => {
    e.preventDefault();
    if (this.state.email && this.state.password && this.state.reCaptchaVerify) {
      try {
        await this.props.authenticate(this.state.email, this.state.password, this.state.reCaptchaVerify);
        history.push(ROUTES.HOME);
      } catch (err) {
        const isLocalhost = window.location.hostname === 'localhost';
        // Localhost skips ReCAPTCHA UI — keep the bypass token so the button stays enabled.
        // Non-local: reset widget so user can solve captcha again.
        if (isLocalhost) {
          this.setState({ reCaptchaVerify: PreferencesData.noReCaptcha });
        } else if (this.state.reCaptchaRef.current) {
          this.setState({ reCaptchaVerify: '' });
          this.state.reCaptchaRef.current.reset();
        }

        const errorCode = err.response && err.response.data && err.response.data.error
          && err.response.data.error.code;
        if (errorCode === 209) {
          this.setState({ message: I18n.t('userBlocked') });
        } else if (errorCode === 400) {
          this.setState({ message: I18n.t('userNotFound') });
        } else if (errorCode === 407 || errorCode === 1627) {
          this.setState({ message: I18n.t('userInvalidPassword') });
        } else if (errorCode === 1715) {
          this.setState({ message: I18n.t('reCaptchaValidationFailed') });
        } else {
          this.setState({ message: I18n.t('errorOcurred') });
        }
      }
    }
  };

  onReCaptchaChange = token => this.setState({ reCaptchaVerify: token })

  onReCaptchaExpired = () => this.setState({ reCaptchaVerify: false })

  render() {
    const { message } = this.state;
    return (
      <div className="login-content">
        <form onSubmit={this.onSubmit} className="margin-bottom-0">
          <div className="form-group m-b-20">
            <p className="margin-bottom-5">
              <Translate value="email" />
            </p>
            <input
              type="text"
              className="form-control form-control-lg inverse-mode"
              value={this.state.email}
              onChange={this.onEmailChange}
              required
              maxLength={FIELDS.max}
            />
          </div>
          <div className="form-group m-b-20">
            <p className="margin-bottom-5">
              <Translate value="password" />
            </p>
            <input
              type="password"
              className="form-control form-control-lg inverse-mode"
              value={this.state.password}
              onChange={this.onPasswordChange}
              required
              maxLength={FIELDS.password_max}
            />
          </div>
          <div>
            {window.location.hostname !== 'localhost' && (
              <ReCAPTCHA
                ref={this.state.reCaptchaRef}
                style={{ display: 'flex', justifyContent: 'center', margin: '15px' }}
                sitekey={PreferencesData.keyReCaptcha}
                onChange={this.onReCaptchaChange}
                onExpired={this.onReCaptchaExpired}
              />
            )}
          </div>
          <div className="login-buttons">
            <button
              type="submit"
              className="btn btn-success btn-block btn-lg"
              disabled={!this.state.reCaptchaVerify}
            >
              <Translate value="signIn" />
            </button>
          </div>
          <p style={{ marginTop: '5px' }} className="color-red">{message}</p>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  authenticate: (email, password, reCaptchaVerify) => dispatch(authenticate(email, password, reCaptchaVerify)),
});

export default connect(undefined, mapDispatchToProps)(LoginForm);
